import { render, staticRenderFns } from "./ReportGenerator.vue?vue&type=template&id=3c0870c9&scoped=true&"
import script from "./ReportGenerator.vue?vue&type=script&lang=js&"
export * from "./ReportGenerator.vue?vue&type=script&lang=js&"
import style0 from "./ReportGenerator.vue?vue&type=style&index=0&id=3c0870c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0870c9",
  null
  
)

export default component.exports